// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--3f_LB","left":"Layout-module--left--3uWkZ","center":"Layout-module--center--2XZ7Q","right":"Layout-module--right--2ZFLC"};